<div class="*:transition-all">
    <button
        id="appButton"
        [type]="type()"
        [ngClass]="[currentStyle(), currentStateStyle(), currentSize()]"
        [class.w-full]="expand()"
        [disabled]="disabled()"
        [style.width]="width()"
    >
        @if (icon()) {
            <lepi-icon [name]="icon()!" class="bg-current md:size-5 size-4" />
        }
        <ng-content />
    </button>
</div>
